import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

export const getIsInitialActivitySetPollLoading = (state) => {
  // In NATS mode, we don't wait for activity set polling - labor ticket is source of truth
  const natsFlowEnabled = getPostLaborUpdatesOnNats(state);
  if (natsFlowEnabled) {
    return false;
  }
  return !!state.recentActivitySetsPoll.isInitialPollLoading;
};
